import { defineStore } from "pinia";
import axios from "@/utils/axios";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";

export const useExamFetchStore = defineStore("ExamFetch", {
  state: () => ({
    examQuestions: [],
    examData: null,

    myExamSubmission: [],
    examDetail: null,
    examSubmissionDetail: null,
    submissionByExamList: [],
    answerListBySubmission: [],
    myCertificatesList: [],
    coursesWithCertificatesList: [],
    courseCertificatesList: [],
  }),
  actions: {
    // fetch question
    async fetchQuestionsByExam(examID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/questions/`,
          { params: { examID: examID } }
        );
        this.examQuestions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async fetchStudentQuestionsByExam(examID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/questions/student/`,
          { params: { examID: examID } }
        );
        this.examQuestions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },
    // fetch all exam submission
    async fetchExamSubmissionsListBySelf() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();
      const userID = authStore.currentUser.id;
      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/exam-submissions/`,
          {
            params: { studentID: userID }, // kalau ada examID, filter
          }
        );
        this.myExamSubmission = response.data;
      } catch (error) {
        console.error("Error fetching submissions:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    // fetch exam submission detail
    async fetchExamSubmissionsDetail(submissionID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();
      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/exam-submissions/${submissionID}`
        );
        this.examSubmissionDetail = response.data;
      } catch (error) {
        console.error("Error fetching submissions:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    // fetch exam submission detail by examID
    async fetchExamSubmissionsByExam(examID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/exams/${examID}`
        );
        this.examDetail = response.data;
      } catch (error) {
        console.error("Error fetching exam:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    // fetch exam submission list by examID
    async fetchExamSubmissionsList(examID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/exam-submissions/`,
          {
            params: { examID: examID }, // kalau ada examID, filter
          }
        );
        this.submissionByExamList = response.data;
      } catch (error) {
        console.error("Error fetching submissions:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    // fetch answer list by submission
    async fetchAnswerListBySubmission(submissionID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(`${authStore.Url}/api/exam/answers/`, {
          params: { submission: submissionID }, // kalau ada examID, filter
        });
        this.answerListBySubmission = response.data;
      } catch (error) {
        console.error("Error fetching submissions:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async fetchMyCertificates() {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();
      const id = authStore.currentUser.id;

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/exam/certificates/`,
          {
            params: {
              studentID: id, // filter certificate milik student yang login
            },
          }
        );

        this.myCertificatesList = response.data;
        return response.data;
      } catch (error) {
        console.error("Gagal mengambil certificate:", error);
        throw error;
      } finally {
        sharedStore.endRequest();
      }
    },

    async fetchCoursesWithCertificates(search = "") {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();
      sharedStore.startRequest();
      try {
        let coursesData = [];
        try {
          // Coba panggil endpoint custom jika sudah ada
          const response = await axios.get(
            `${authStore.Url}/api/exam/certificates/courses-with-certificates/`,
            { params: search ? { search } : {} }
          );
          if (Array.isArray(response.data)) {
            coursesData = response.data;
          }
        } catch (err) {
          // Jika 404 (server backend remote belum di-deploy update baru), gunakan fallback
          console.warn(
            "Endpoint courses-with-certificates 404, beralih ke fallback endpoint standar:",
            err?.message
          );

          // 1. Ambil semua certificates
          const certRes = await axios.get(`${authStore.Url}/api/exam/certificates/`);
          const allCertificates = certRes.data || [];

          if (allCertificates.length > 0) {
            // 2. Ambil daftar kursus dari /api/courses/manage
            let courseList = [];
            try {
              const courseRes = await axios.get(`${authStore.Url}/api/courses/manage`);
              courseList = courseRes.data || [];
            } catch (cErr) {
              console.error("Gagal load course list:", cErr);
            }

            // 3. Kelompokkan sertifikat berdasarkan courseID
            const certsByCourse = {};
            allCertificates.forEach((c) => {
              const cId = c.courseID;
              if (!cId) return;
              if (!certsByCourse[cId]) {
                certsByCourse[cId] = [];
              }
              certsByCourse[cId].push(c);
            });

            // 4. Bangun data course bersertifikat
            Object.keys(certsByCourse).forEach((courseIdStr) => {
              const cId = Number(courseIdStr) || courseIdStr;
              const certs = certsByCourse[cId];
              const courseObj = courseList.find(
                (c) => String(c.course_id) === String(cId)
              ) || {};

              // Cari latest_issued
              let latestIssued = null;
              certs.forEach((c) => {
                if (c.issuedDate) {
                  if (!latestIssued || new Date(c.issuedDate) > new Date(latestIssued)) {
                    latestIssued = c.issuedDate;
                  }
                }
              });

              // Kategori / group name
              let categoryName = "-";
              if (courseObj.course_group?.name) {
                categoryName = courseObj.course_group.name;
              } else if (typeof courseObj.course_group === "string") {
                categoryName = courseObj.course_group;
              }

              // Thumbnail
              let thumb = courseObj.thumbnail || null;
              if (thumb && !thumb.startsWith("http") && !thumb.startsWith("/")) {
                thumb = `/media/${thumb}`;
              }

              coursesData.push({
                course_id: cId,
                title: courseObj.title || certs[0]?.courseName || `Course #${cId}`,
                level: courseObj.level || "Fundamental",
                status: courseObj.status || "Active",
                category: categoryName,
                instructor_name: courseObj.instructor_name || authStore.userName(courseObj.instructor) || "-",
                thumbnail: thumb,
                total_certificates: certs.length,
                latest_issued: latestIssued,
              });
            });

            // Sort descending berdasarkan latest_issued
            coursesData.sort((a, b) => new Date(b.latest_issued || 0) - new Date(a.latest_issued || 0));

            // Jika ada search query
            if (search) {
              const q = search.toLowerCase();
              coursesData = coursesData.filter((c) =>
                c.title?.toLowerCase().includes(q)
              );
            }
          }
        }

        this.coursesWithCertificatesList = coursesData;
        return coursesData;
      } catch (error) {
        console.error("Gagal mengambil course dengan certificate:", error);
        this.coursesWithCertificatesList = [];
        return [];
      } finally {
        sharedStore.endRequest();
      }
    },

    async fetchCertificatesByCourse(courseID, search = "") {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();
      sharedStore.startRequest();
      try {
        const params = { courseID };
        const response = await axios.get(
          `${authStore.Url}/api/exam/certificates/`,
          { params }
        );
        let list = response.data || [];
        // Pastikan hanya courseID yang sesuai
        list = list.filter((item) => String(item.courseID) === String(courseID));
        this.courseCertificatesList = list;
        return list;
      } catch (error) {
        console.error("Gagal mengambil certificates by course:", error);
        this.courseCertificatesList = [];
        return [];
      } finally {
        sharedStore.endRequest();
      }
    },

    async deleteCertificate(certificateID) {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();
      sharedStore.startRequest();
      try {
        await axios.delete(
          `${authStore.Url}/api/exam/certificates/${certificateID}/`
        );
        return true;
      } catch (error) {
        console.error("Gagal menghapus certificate:", error);
        throw error;
      } finally {
        sharedStore.endRequest();
      }
    },
  },
});
